import { getStyleguideSections } from "@toolkit/Framework/Store/Toolkit/Components/Styleguide/StyleguideSelectors";
import StyleguideState from "@toolkit/Framework/Store/Toolkit/Components/Styleguide/StyleguideState";
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

export interface OpenAllStyleguideSectionsParameter {
    isOpen: boolean;
}

export interface OpenAllStyleguideSectionsHandlerProps extends StyleguideState {}

type HandlerType = Handler<OpenAllStyleguideSectionsParameter, OpenAllStyleguideSectionsHandlerProps>;

export const PopulateStyleguideSections: HandlerType = props => {
    const sections = getStyleguideSections(props.getState());
    const newSectionsValue = sections?.map(x => {
        return { ...x, isOpen: props.parameter.isOpen };
    });

    props.sections = newSectionsValue;
};

export const DispatchOpenAllStyleguideSections: HandlerType = props => {
    props.dispatch({
        type: "Toolkit/Components/Styleguide/OpenAllStyleguideSections",
        sections: props.sections,
        isOpen: props.parameter.isOpen,
    });
};

export const chain = [PopulateStyleguideSections, DispatchOpenAllStyleguideSections];

const openAllStyleguideSections = createHandlerChainRunner(chain, "OpenAllStyleguideSections");

export default openAllStyleguideSections;
